<template>
  <div class="d-flex">
    <div class="tabs mt-4 px-2 py-1">
      <button
        @click="$emit('tab-change', 1)"
        class="tabs_btn"
        :class="`${active === 1 ? 'tabs_btn_active' : ''}`"
      >
        Overview
      </button>
      <button
        @click="$emit('tab-change', 2)"
        class="tabs_btn"
        :class="`${active === 2 ? 'tabs_btn_active' : ''}`"
      >
        ONU Realtime
        <span
          v-if="onuRealtimeLoader && active === 2"
          class="spinner-border spinner-border-sm mx-3"
        ></span>
      </button>
      <button
        @click="$emit('tab-change', 3)"
        class="tabs_btn"
        :class="`${active === 3 ? 'tabs_btn_active' : ''}`"
      >
        Tasks
      </button>
      <button
        @click="$emit('tab-change', 4)"
        class="tabs_btn"
        :class="`${active === 4 ? 'tabs_btn_active' : ''}`"
      >
        Hosts
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "GraphTabs",
  props: {
    active: {
      type: Number,
      default: 1,
    },
    onuRealtimeLoader: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

